"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("../../../../core");
exports.default = {
    getPolices: new core_1.HttpProxy({
        method: core_1.METHOD.POST,
        url: '/reports/policies',
    }),
    changePriority: new core_1.HttpProxy({
        method: core_1.METHOD.POST,
        url: '/policies/changePriority',
    }),
};
//# sourceMappingURL=policyPriorityOrderDialogProxy.js.map